// Ausserbetriebsetzung

// state
const state = {
    channelFuel: true,
    channelEnergy: true,
    channelServices: true,
    channelPellets: true,
    channelDiesel: true,
    channelInfo: true
}

// getters
const getters = {
    getChannelTotal: state => {
        if (state.channelFuel == false && state.channelEnergy == false && state.channelServices == false &&
            state.channelPellets == false && state.channelDiesel == false && state.channelInfo == false)
            return false;
        else
            return true;
    }
}

// actions
const actions = {

}

// mutations
const mutations = {
    setChannelTotal(state, newValue) {
        state.channelFuel = newValue;
        state.channelEnergy = newValue;
        state.channelServices = newValue;
        state.channelPellets = newValue;
        state.channelDiesel = newValue;
        state.channelInfo = newValue;
    },
    setChannelFuel(state, newValue) {
        state.channelFuel = newValue;
    },
    setChannelEnergy(state, newValue) {
        state.channelEnergy = newValue;
    },
    setChannelServices(state, newValue) {
        state.channelServices = newValue;
    },
    setChannelPellets(state, newValue) {
        state.channelPellets = newValue;
    },
    setChannelDiesel(state, newValue) {
        state.channelDiesel = newValue;
    },
    setChannelInfo(state, newValue) {
        state.channelInfo = newValue;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}